<template>
    <header>
      <div class="w-100 overflow-hidden position-absolute">
        <BackGroundImg :headerBackground="headerBackground" />
      </div>

      <div class="container-fluid p-0 w-100 text-white">
        <!-- 預設樣式 begin -->
        <div class="row no-gutters align-items-center" style="min-height: 48px;">
          <div class="col-3">
            <div class="py-2 px-3">
              <span class="material-icons" @click="$router.go(-1)">
                keyboard_arrow_left
              </span>
            </div>
          </div>
          <div class="col-6 text-center">
            <span class="font-weight-bold mx-1 align-middle">{{ title }}</span>
          </div>
          <div class="col-3 text-right">
          </div>
        </div>
        <!-- 預設樣式 end -->
      </div>
    </header>
</template>

<script>
import BackGroundImg from '@/components/mcf/BackGroundImg.vue';

export default {
  components: {
    BackGroundImg,
  },
  props: {
    title: String,
    headerBackground: String,
  },
};
</script>

<style>

</style>
